<template>
<div>
    <div class="row">&nbsp;</div>
    <div class="row">&nbsp;&nbsp;Volgende tijden zijn beschikbaar&nbsp;op&nbsp;<strong>{{record.DateInfo}}</strong> &nbsp;<i v-show="!showfreeplaces" class="ion-arrow-down-c" @click="showfreeplaces = !showfreeplaces"></i></div>
    <div class="row titleMenuBasket">&nbsp;&nbsp;</div>
    <div class="row">&nbsp;</div>
    <div class="row col-24">
     <template  v-for="rec in getFreeTimes">
       <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6" v-show="showfreeplaces">
         <div class="time-btn" @click="freePlaceClicked (rec)" :style="buttonStyles">
            <a  :style="buttonStyles">{{rec.TimeInfo}}</a>
         </div>
       </div>
      </template>
    </div>

     <div class="row">
        <div class="col-12" v-show="!showfreeplaces">
            <div v-if="selectedTime !== undefined">Gekozen afspraak : <br>
            <strong>{{record.DateInfo}}</strong> om  <strong style="font-size:100%">{{this.selectedTime.TimeInfo}}</strong>
            </div>
        </div>
        <div class="col-12 top-bar-right" v-show="!showfreeplaces">
          <div class="product-btn"  v-bind:class="{ 'product-btn__color': this.canContinue }">
              <a  @click="confirmReservation();" v-bind:style="{ 'background-color': getColorApp, color: '#ffffff'}"><i class="ion-bag" ></i>Volgende</a>
            </div>
        </div>
      </div>
    <div class="row">&nbsp;</div>
</div>

</template>

<style>
.time-btn a {
    color: #f8f8f8;
    font-size: 15px;
    line-height: 1;
    display: inline-block;
    padding: 12px 12px 12px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    background-color: #ebebeb;
    text-transform: capitalize;
    margin-bottom: 10px;
    border-width: 1px;
    border-style: solid;
    font-weight: 700;
}
.timebtnactive a
{
 
    color: #fff;
    font-size: 15px;
    line-height: 1;
    display: inline-block;
    padding: 12px 12px 12px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    text-transform: capitalize;
    margin-bottom: 10px;
}

</style>

<script>
import myHttpApi from "../../api/myhttpapi";
import Vue from 'vue';

import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../../store/mutation-types'

  export default {
    props: ['record', 'canGoNext'],
    data () {
      return {
          selectedTime : undefined,
          showfreeplaces : true,
          canGoNextPage : false
      }
    },
    components: {
    },
    mounted () {
      this.canGoNextPage = this.canGoNext;
      this.showfreeplaces = true;
    },
    computed: {
       canContinue () {
         if (!this.canGoNextPage)
         {
           this.showfreeplaces = true;
         }
         return this.canGoNextPage;
       },
      getFreeTimes () {
        this.showfreeplaces = true;
        return this.record.Records;
      },
      getColorApp () {
           if (this.selectedTime == undefined) return "#ebebeb";

           if (!this.selectedTime.IsSelected)
           {
             return "#ebebeb";
           }
           else
           {
              return Vue.$storeSettings.ColorApp;
           }
           
       }
    },
    methods: {
      checkOut () {
        //this.$router.push('/custappoint');
      },
      freePlaceClicked (item) {
        console.log (item.TimeInfo);
        item.IsSelected = true;
        this.canGoNextPage = true;
        this.selectedTime = item;
        this.showfreeplaces = false;
      },
      confirmReservation () {
         if (this.canGoNextPage)
         {
            Vue.$selectedTime = this.selectedTime;
            this.$router.push('/confirm');
         }
         else
         {
            alert ("Kies een tijdstip aub");
         }
      },
      buttonStyles(){
        return {
            backgroundColor : this.selectedTime.IsSelected ? Vue.$storeSettings.ColorApp  : "#ddd",
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cart/CartFreePlace.vue